import React from 'react'
import Svg, { G, Path, SvgProps, Rect } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconBuilding = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconBuilding.dimensions.width} ${IconBuilding.dimensions.height}`}
      {...otherProps}
    >
      <G fill="none" fillRule="evenodd">
        <Path
          fill={color || Color.premiumBlack}
          fillRule="nonzero"
          d="M9.767 0v.92h1.21v3.865h1.258c1.091 0 1.976.927 1.976 2.064v2.429a4.055 4.055 0 0 0-.535-.028v-2.4c0-.83-.649-1.508-1.444-1.508l-1.255-.001v5.009c-.2.19-.38.4-.539.628l.002-6.192.003-3.306H3.675v11.962h1.667V8.909h3.446l-.001 4.532h.936v.296c0 .088.004.176.01.263l-.946-.001-3.445.002-1.733-.002L0 14V6.849c0-1.14.887-2.064 1.975-2.064h1.168V.921L4.36.92V0h5.408Zm-6.69 5.34H1.979c-.795 0-1.443.678-1.443 1.509v6.592h2.543v-8.1Zm3.717 4.125h-.92v3.977l.92-.001V9.465Zm1.459 0h-.924v3.976h.924V9.466Zm-1.7-3.887v1.973H4.66V5.578h1.892Zm2.913 0v1.973H7.574V5.578h1.892Zm-3.448.556h-.825v.858h.825v-.858Zm2.913 0h-.825v.858h.825v-.858ZM6.553 2.862v1.973H4.66V2.862h1.892Zm2.913 0v1.973H7.574V2.862h1.892Zm-3.448.556h-.825v.858h.825v-.858Zm2.913 0h-.825v.858h.825v-.858Zm.302-2.86H4.89v.363h4.342V.559Z"
        />
        <Path stroke={color || Color.premiumBlack} strokeWidth={0.6} d="M13.704 10.5v6-6Zm-2.967 3.034h6-6Z" />
        <Rect
          width={8.026}
          height={8.5}
          x={9.724}
          y={9.25}
          stroke={color || Color.premiumBlack}
          strokeWidth={0.5}
          rx={4.013}
        />
      </G>
    </Svg>
  )
}

IconBuilding.dimensions = {
  width: 20,
  height: 20,
}

export default IconBuilding
